import React from 'react'
import {getSizedImageUrl} from '@shopify/theme-images';
import Price from '../../Price'
import LoadingIcon from './Loading'

import {LineItem} from '../../../util/typings'
import useCartLineItem from '../../../hooks/useCartLineItem'
import getRoute from '../../../../scripts/utils/getRoute';
import formatSizeNames from '../../../../scripts/utils/formatSizeNames'


type Props = {
  lineItem: LineItem,
  langStrings: Record<string, string>
}

const CartLineItem: React.FunctionComponent<Props> = ({ lineItem, langStrings }: Props) => {
  const { removeText, freeGiftMessage } = langStrings;
  const { increment, changeQuantity, decrement, remove, removing, itemUpdating, displayQuantity } = useCartLineItem(lineItem)
  
  return (
    <li className={`minicart-item ${removing ? 'removing' : ''}`}>
      <div className="minicart-item-image-wrap">
        <a href={`${getRoute()}products/${ lineItem.handle }`}>
          <img alt={lineItem.product_title} loading="lazy" width="112" height="168" src={getSizedImageUrl(lineItem.featured_image.url, '224x336')}></img>
        </a>
      </div>
      <div className="minicart-item-details">
        <h5 className="minicart-item-title">
          <a href={`${getRoute()}products/${lineItem.handle}`}> {lineItem.product_title}{lineItem.variant_title ? ` - ${formatSizeNames(lineItem.variant_title, null, null, true)}` : ''}</a>
        </h5>
        { lineItem.price !== 0 && !Object.keys(lineItem.properties).includes('_free_gift') ? (
          <>
            <Price cart={true} product={lineItem}></Price>
            <div className="minicart-items-quantity">
              <button  disabled={parseInt(displayQuantity.toString()) < 2 || itemUpdating} onClick={decrement}>-</button>
              <span className="minicart-item-quantity-number">
                { itemUpdating ? (<LoadingIcon />) : ''}
                <input
                  type="number"
                  disabled={itemUpdating}
                  value={displayQuantity}
                  onBlur={(e) => !e.target.value ? changeQuantity(lineItem.quantity) : null} //if blank when blured switch back to actual value
                  onChange={e => changeQuantity(e.target.value)}
                ></input>
              </span>
              <button disabled={itemUpdating} onClick={increment}>+</button>
            </div>
            <button className="minicart-item-remove" onClick={remove}>{ removeText }</button>
          </>
        ) : Object.keys(lineItem.properties).includes('_free_gift') ?
          (<p>{ freeGiftMessage }</p>)
          : null }
        
      </div>
    </li>

  )
}

export default CartLineItem